import LogoMark from "./LogoMark";
import { scrollToId } from "../lib/scroll";
import { PHONE_DISPLAY, PHONE_TEL, INSTAGRAM_HANDLE, INSTAGRAM_URL, YOUTUBE_HANDLE, YOUTUBE_URL } from "../site";

const LINKS = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "achievements", label: "Achievements" },
    { id: "training", label: "Training" },
    { id: "coaching", label: "Coaching" },
    { id: "journey", label: "Journey" },
    { id: "contact", label: "Contact" },
];

export default function Footer() {
    return (
        <footer className="border-t border-[#D4A017]/15 bg-[#070707]">
            <div className="mx-auto max-w-7xl px-4 py-14 sm:px-8 lg:px-16">
                <div className="grid gap-10 md:grid-cols-3">
                    <div>
                        <div className="flex items-center gap-3">
                            <LogoMark size={34} />
                            <span className="font-display text-2xl tracking-[0.16em] text-white">
                                ARYAN <span className="text-gold-grad">YOGA</span>
                            </span>
                        </div>
                        <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.26em] text-[#F5C542]">
                            Trainer Aryan · Certified National Yoga Coach
                        </p>
                        <p className="mt-3 text-xs tracking-wide text-[#B8B8B8]">
                            Advanced Yogasana | Competition Training | Personal Coaching
                        </p>
                    </div>

                    <div>
                        <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#B8B8B8]">
                            Navigate
                        </p>
                        <nav className="mt-4 flex flex-wrap gap-x-6 gap-y-2">
                            {LINKS.map((l) => (
                                <a
                                    key={l.id}
                                    href={`#${l.id}`}
                                    data-testid={`footer-link-${l.id}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        scrollToId(l.id);
                                    }}
                                    className="text-xs uppercase tracking-[0.16em] text-white/60 transition-colors hover:text-[#F5C542]"
                                >
                                    {l.label}
                                </a>
                            ))}
                        </nav>
                    </div>

                    <div>
                        <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#B8B8B8]">
                            Contact
                        </p>
                        <div className="mt-4 flex flex-col gap-2.5">
                            <a
                                href={PHONE_TEL}
                                data-testid="footer-phone"
                                className="text-sm tracking-wide text-white/80 transition-colors hover:text-[#F5C542]"
                            >
                                Phone: {PHONE_DISPLAY}
                            </a>
                            <a
                                href={INSTAGRAM_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-instagram"
                                className="text-sm tracking-wide text-white/80 transition-colors hover:text-[#F5C542]"
                            >
                                Instagram: {INSTAGRAM_HANDLE}
                            </a>
                            <a
                                href={YOUTUBE_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-youtube"
                                className="text-sm tracking-wide text-white/80 transition-colors hover:text-[#F5C542]"
                            >
                                YouTube: {YOUTUBE_HANDLE}
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-12 h-px bg-gradient-to-r from-transparent via-[#D4A017]/35 to-transparent" />
                <p className="mt-6 text-center text-[11px] tracking-[0.18em] text-white/40">
                    © 2026 Trainer Aryan. All Rights Reserved.
                </p>
            </div>
        </footer>
    );
}
